import _ from "lodash";

// Constants
import { propsOptions } from "../../../../../../../../utils/asanas";
import { contraindicationsOptions } from "../../../../../../sequence/components/asanas/edit/components/form/constants";

// Locales
import I18n from "../../../../../../../../i18n";

export const OPERATOR_MAP = {
    '=': 'equal',
    '!=': 'notEqual',
    '<': 'lessThan',
    '<=': 'lessThanInclusive',
    '>': 'greaterThan',
    '>=': 'greaterThanInclusive',
    'in': 'in',
    'notIn': 'notIn',
    'contains': 'contains',
    'doesNotContain': 'doesNotContain',
    // Agrega aquí cualquier otro que uses en FIELDS
};

export const REVERSE_OPERATOR_MAP = _.invert(OPERATOR_MAP);

const getPrimaryChainOptions = () => [
    { name: 'scapular_girdle', label: I18n.t('personalizedSequence.rules.primaryChainOptions.scapular_girdle') },
    { name: 'pelvic_girdle', label: I18n.t('personalizedSequence.rules.primaryChainOptions.pelvic_girdle') },
    { name: 'torso_front', label: I18n.t('personalizedSequence.rules.primaryChainOptions.torso_front') },
    { name: 'torso_rear', label: I18n.t('personalizedSequence.rules.primaryChainOptions.torso_rear') },
    { name: 'neck', label: I18n.t('personalizedSequence.rules.primaryChainOptions.neck') },
    { name: 'right_arm', label: I18n.t('personalizedSequence.rules.primaryChainOptions.right_arm') },
    { name: 'left_arm', label: I18n.t('personalizedSequence.rules.primaryChainOptions.left_arm') },
    { name: 'right_leg', label: I18n.t('personalizedSequence.rules.primaryChainOptions.right_leg') },
    { name: 'left_leg', label: I18n.t('personalizedSequence.rules.primaryChainOptions.left_leg') },
    { name: 'currentAsanaChain', label: I18n.t('personalizedSequence.rules.primaryChainOptions.currentAsanaChain') }
    // Agrega aquí cualquier otra que maneje tu base de datos de asanas
];

const CONTRAINDICATIONS_LIST = _.map(contraindicationsOptions, (label, name) => ({
    name, // El key técnico: "lumbar.withInjury.hernia"
    label // El texto amigable: "Hernia Lumbar / Discal"
}));

const RHYTHM_OPTIONS = [
    { name: 'slow', label: 'Lento (Restaurativo)' },
    { name: 'moderate', label: 'Moderado (Hatha)' },
    { name: 'fast', label: 'Dinámico (Vinyasa)' }
];

const PROPS_OPTIONS = _.map(propsOptions, (label, name) => ({
    name,
    label
}));

export const getFields = () => [
    // --- DATOS GLOBALES ---
    { name: 'toneAverage', label: I18n.t('personalizedSequence.rules.fields.toneAverage'), inputType: 'number' },
    { name: 'elasticityAverage', label: I18n.t('personalizedSequence.rules.fields.elasticityAverage'), inputType: 'number' },
    { name: 'bodyBalanceLevel', label: I18n.t('personalizedSequence.rules.fields.bodyBalanceLevel'), inputType: 'number' },

    // --- MATRIZ DE TONO (detailedAverages.toneAverages) ---
    { name: 'detailedAverages.toneAverages.torso_rear', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.toneAverages.torso_rear') },
    { name: 'detailedAverages.toneAverages.torso_front', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.toneAverages.torso_front') },
    { name: 'detailedAverages.toneAverages.scapular_girdle', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.toneAverages.scapular_girdle') },
    { name: 'detailedAverages.toneAverages.pelvic_girdle', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.toneAverages.pelvic_girdle') },

    // --- MATRIZ DE MOVILIDAD (detailedAverages.mobilityAverages) ---
    { name: 'detailedAverages.mobilityAverages.right_hip_ext', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.mobilityAverages.right_hip_ext') },
    { name: 'detailedAverages.mobilityAverages.neck_flexion', label: I18n.t('personalizedSequence.rules.fields.detailedAverages.mobilityAverages.neck_flexion') },

    // --- PREFERENCIAS DEL USUARIO (WIZARD - HOY) ---
    {
        name: 'user.rhythm',
        label: I18n.t('personalizedSequence.rules.fields.user.rhythm'),
        operators: ['=', '!='],
        valueEditorType: 'select',
        values: RHYTHM_OPTIONS
    },
    {
        name: 'user.sensitivity.intensity',
        label: I18n.t('personalizedSequence.rules.fields.user.sensitivity.intensity'),
        inputType: 'number', // 1 a 5
        operators: ['=', '>', '<', '>=', '<=']
    },
    {
        name: 'user.sensitivity.affectedAreas',
        label: I18n.t('personalizedSequence.rules.fields.user.sensitivity.affectedAreas'),
        operators: ['contains', 'doesNotContain', 'containsFact'],
        valueEditorType: 'select',
        values: getPrimaryChainOptions() // Usamos las mismas cadenas para que coincidan
    },
    {
        name: 'user.props',
        label: I18n.t('personalizedSequence.rules.fields.user.props'),
        operators: ['contains', 'doesNotContain'],
        valueEditorType: 'multiselect',
        values: PROPS_OPTIONS
    },

    // --- METADATOS DE LA ASANA (Contexto del Programa) ---
    {
        name: 'asana.primaryChain',
        label: I18n.t('personalizedSequence.rules.fields.asana.primaryChain'),
        operators: ['=', '!=', 'in'],
        valueEditorType: 'select', // Indica que queremos un selector
        values: getPrimaryChainOptions() // Pasa la lista de opciones
    },
    {
        name: 'asana.difficultyScore.max',
        label: I18n.t('personalizedSequence.rules.fields.asana.difficultyScore.max'),
        inputType: 'number'
    },
    {
        name: 'asana.isAdvanced',
        label: I18n.t('personalizedSequence.rules.fields.asana.isAdvanced'),
        valueEditorType: 'checkbox'
    },
    {
        name: 'asana.isBeginner',
        label: I18n.t('personalizedSequence.rules.fields.asana.isBeginner'),
        valueEditorType: 'checkbox'
    },
    {
        name: 'asana.contraindications',
        label: I18n.t('personalizedSequence.rules.fields.asana.contraindications'),
        operators: ['contains', 'doesNotContain'],
        valueEditorType: 'select',
        values: CONTRAINDICATIONS_LIST // La lista que generamos arriba
    }
];

// Definimos los tipos de acciones (eventos) disponibles
export const getConsequentTypes = () => [
    { name: 'substitute-variant', label: I18n.t('personalizedSequence.rules.consequentTypes.substitute-variant') },
    { name: 'adjust-time', label: I18n.t('personalizedSequence.rules.consequentTypes.adjust-time') },
    { name: 'force-props', label: I18n.t('personalizedSequence.rules.consequentTypes.force-props') },
    { name: 'insert-compensation', label: I18n.t('personalizedSequence.rules.consequentTypes.insert-compensation') }
];

// Mantener compatibilidad con código existente que usa FIELDS y CONSEQUENT_TYPES directamente
export const FIELDS = getFields();
export const CONSEQUENT_TYPES = getConsequentTypes();